var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "amploy__faq__triangle",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 377 351.86",
    style: {
      enableBackground: "new 0 0 377 351.86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.4,60.64c-2.31-3.98-6.42-6.35-11.02-6.35c-0.01,0-0.02,0-0.03,0l-137.33,0.35L79,54.85l-29.18,0.06 c-4.6,0-8.72,2.39-11.02,6.39c-2.29,3.99-2.28,8.75,0.02,12.74l137.67,237.39h0c2.31,3.97,6.42,6.34,11.01,6.34 c1.15,0.04,2.24-0.14,3.31-0.43c3.27-0.87,6.02-2.98,7.73-5.96l68.37-118.96l68.51-119.04C337.72,69.39,337.72,64.62,335.4,60.64z  M187.51,307.18c-0.79,0-1.47-0.39-1.86-1.07L47.97,68.72c-0.4-0.68-0.4-1.47,0-2.15c0.29-0.5,0.75-0.86,1.29-1 c0.19-0.05,0.38-0.07,0.57-0.07l137.21-0.27l137.34-0.35c0,0,0.01,0,0.01,0c0.79,0,1.46,0.39,1.86,1.07c0.4,0.68,0.4,1.47,0,2.15 l-68.51,119.04l-68.37,118.96C188.98,306.79,188.3,307.18,187.51,307.18C187.51,307.18,187.51,307.18,187.51,307.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.1abd8c571971668d3ebfaf5ea67db110.svg";
export { ForwardRef as ReactComponent };